import { Action } from "../types"
import { TooltipAction } from "./actions"
import { TooltipState } from "./types"

const initial_tooltip: TooltipState = {
  text: null,
  style: {
    visibility: 'hidden'
  }
}

const tooltipReducer = (state = initial_tooltip, action: Action): TooltipState => {
  const { data, type } = action ?? {}
  switch (type) {
    case TooltipAction.HIDE_TOOLTIP:
      return initial_tooltip
      break
    
    case TooltipAction.UPDATE_TOOLTIP:
      return {
        ...state,
        ...data
      }
      break

    default:
      return state
  }
}

export { tooltipReducer, initial_tooltip }
